import { useBannerSettings } from 'hooks/useBannerSettings';
import React, { FC } from 'react';
import { Alert, AlertTitle } from '@mui/material';

const AppBanner: FC = () => {
    const { bannerSettings } = useBannerSettings();

    const activeBanners = bannerSettings.filter((banner) => banner.isEnabled);

    if (activeBanners.length === 0) return null;

    return (
        <>
            {activeBanners.map((banner, bannerIndex) => (
                <Alert key={bannerIndex} severity={banner.severity} sx={{ mb: 2 }}>
                    <AlertTitle>{banner.title}</AlertTitle>
                    {banner.message}
                </Alert>
            ))}
        </>
    );
};

export default AppBanner;
